/// Preferência de notificação por navegador: quem toca é o aparelho, não a conta.
const ENABLED_KEY = 'crm.notificacoes';
const SINCE_KEY = 'crm.notificacoes.desde';
const NOTIFIED_KEY = 'crm.notificacoes.avisadas';

/// A tela que liga e desliga avisa o hook que já está rodando, na mesma aba.
export const NOTIFICATIONS_CHANGED = 'crm-notificacoes';

export const notificationsSupported = () => typeof window !== 'undefined' && 'Notification' in window;

export const notificationsEnabled = () =>
    notificationsSupported() && Notification.permission === 'granted' && localStorage.getItem(ENABLED_KEY) === 'on';

export const setNotificationsEnabled = (enabled: boolean) => {
    if (enabled) localStorage.setItem(ENABLED_KEY, 'on');
    else localStorage.removeItem(ENABLED_KEY);

    window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED));
};

/// Desde quando já se avisou; no localStorage para as abas não avisarem o mesmo lead cada uma.
export const readSince = (now: Date) => localStorage.getItem(SINCE_KEY) ?? now.toISOString();

export const writeSince = (value: string) => localStorage.setItem(SINCE_KEY, value);

/// Ações já avisadas; só as últimas, pois a janela de aviso é de minutos e a lista não cresce sempre.
const NOTIFIED_MAX = 200;

export const wasNotified = (id: string) => readNotified().includes(id);

export const markNotified = (id: string) =>
    localStorage.setItem(NOTIFIED_KEY, JSON.stringify([...readNotified(), id].slice(-NOTIFIED_MAX)));

const readNotified = (): string[] => {
    try {
        return JSON.parse(localStorage.getItem(NOTIFIED_KEY) ?? '[]');
    } catch {
        return [];
    }
};

/// A ação entra no aviso quando falta até isso para ela, e ainda não passou.
export const ACTION_WARNING_MINUTES = 15;

export const actionsToNotify = <T extends { id: string; scheduledAt: string; closedAt?: string | null }>(
    items: T[],
    now: Date,
    alreadyNotified: (id: string) => boolean,
): T[] => {
    const limit = now.getTime() + ACTION_WARNING_MINUTES * 60 * 1000;

    return items.filter((item) => {
        const at = new Date(item.scheduledAt).getTime();

        return !item.closedAt && at >= now.getTime() && at <= limit && !alreadyNotified(item.id);
    });
};
